import { useMemo } from 'react';
import { useShallow } from 'zustand/react/shallow';

import { ABTestingConfig, abTestingFunction } from '@/helpers/abTesting';
import { useCommonStore } from '@/store';

export function useABTesting<T extends object>(
  experiment: string,
  config: ABTestingConfig<T>
): string | React.ComponentType<T> | null {
  const { user, countryCode, cmsABTests, isMobileDevice } = useCommonStore(
    useShallow((state) => ({
      user: state.user,
      countryCode: state.countryCode,
      cmsABTests: state.cmsABTests,
      isMobileDevice: state.isMobileDevice,
    }))
  );

  const availableForTesting = useMemo(
    () =>
      abTestingFunction(
        experiment,
        config,
        user,
        countryCode,
        cmsABTests,
        isMobileDevice
      ),
    [experiment, config, user, countryCode, cmsABTests, isMobileDevice]
  );

  return availableForTesting;
}
